export class SemanticCacheRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  private url(path: string) {
    return `${this.llmService}${path}`;
  }

  categories() {
    return this.api(this.url('/v1/admin/semantic-cache/categories'), this.configService);
  }

  list(params: any) {
    return this.api(this.url('/v1/admin/semantic-cache/records'), this.configService, {
      params,
    });
  }

  getById(id: string) {
    return this.api(
      this.url(`/v1/admin/semantic-cache/records/${id}`),
      this.configService,
    );
  }

  create(data: any) {
    return this.api(this.url('/v1/admin/semantic-cache/records'), this.configService, {
      method: 'POST',
      body: { data },
    });
  }

  update(id: string, data: any) {
    return this.api(
      this.url(`/v1/admin/semantic-cache/records/${id}`),
      this.configService,
      { method: 'PUT', body: { data } },
    );
  }

  remove(id: string) {
    return this.api(
      this.url(`/v1/admin/semantic-cache/records/${id}`),
      this.configService,
      { method: 'DELETE' },
    );
  }

  importCsv(formData: FormData) {
    return this.api(this.url('/v1/admin/semantic-cache/import'), this.configService, {
      method: 'POST',
      body: formData,
    });
  }

  approve(id: string) {
    return this.api(
      this.url(`/v1/admin/semantic-cache/records/${id}/approve`),
      this.configService,
      { method: 'PATCH' },
    );
  }

  approveAll(category?: string) {
    return this.api(
      this.url('/v1/admin/semantic-cache/approve-all'),
      this.configService,
      { method: 'PATCH', params: category && category !== 'all' ? { category } : {} },
    );
  }

  rewrite(data: any) {
    return this.api(this.url('/v1/admin/semantic-cache/rewrite'), this.configService, {
      method: 'POST',
      body: { data },
    });
  }

  test(data: any) {
    return this.api(this.url('/v1/admin/semantic-cache/test'), this.configService, {
      method: 'POST',
      body: { data },
    });
  }
}
